export const refinementRemovedEventName = 'refinementRemoved';
export const refinementsClearedEventName = 'refinementsCleared';

export const ProductActions = {
  fetchProductByCategory: 'product/fetchProductByCategory',
};
export const ReviewsActions = {
  getReviews: 'reviews/getAllReviews',
  getAllReviewByProductId: 'reviews/getAllReviewByProductId',
  getAllReviewBySku: 'reviews/getAllReviewBySku',
  getAllReviewsByReviewSource: 'reviews/getAllReviewsByReviewSource',
  getReviewByKey: 'reviews/getReviewByKey',
  getReviewByAssociatedContentId: 'reviews/getReviewByAssociatedContentId',
  createReview: 'reviews/createReview',
  updateReviewByKey: 'reviews/updateReviewByKey',
  updateReviewByAssociatedContentId: 'reviews/updateReviewByAssociatedContentId',
};

export const CategoryFields = {
  categoryId: 'categoryId',
  categoryIds: 'categoryIds',
  subCategories: 'subCategories',
};
export const Routes = {
  genius_magazine: '/genius-magazine',
  magazine: '/magazin',
  recipe: 'rezepte',
  serviceSubcategory: '/service-subcategory',
};
